module.exports = "/images/fatos-xhengo.png?7156cccdccd4e6a60df7b4bd73355479";